import { config } from '../../../config';
import type { SimulatorTemplate } from '../types';

export const fetchSimulatorTemplates = async (token: string, adminUserUuid: string): Promise<SimulatorTemplate[]> => {
  const url = new URL(`${config.GATEWAY_URL}/api/admin/simulator-templates`);
  url.searchParams.set('adminUserUuid', adminUserUuid);

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch simulator templates: ${response.status} ${response.statusText}`);
  }

  const data = (await response.json()) as SimulatorTemplate[];
  return Array.isArray(data) ? data : [];
};
